import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCar } from "@fortawesome/free-solid-svg-icons";
import { getTimezoneTime } from "./utils";

interface ProductionVolumeItemProps {
  item: any;
  timezone: string;
  bottomLastMargin: string;
  verticalLineStyle: string;
}

const ProductionVolumeItemComponent: React.FC<ProductionVolumeItemProps> = ({
  item,
  timezone,
  bottomLastMargin,
  verticalLineStyle,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const productionContent = item.productionVolume || "No Production Volume";
  const shortProductionContent = productionContent.length > 90
    ? `${productionContent.substring(0, 87)}...`
    : productionContent;

  return (
    <div className={`mt-1 flex flex-col ${bottomLastMargin}`}>
      <div className="flex flex-row">
        <div className="flex h-[30px] w-[30px] min-w-[30px] items-center justify-center rounded-full bg-[#8D8D8D]">
          <FontAwesomeIcon className="h-4 w-4 text-white" icon={faCar} />
        </div>
        <h1 className="ml-3 flex items-center justify-center text-sm text-[#212322]">
          Wrote Daily Production Volume
        </h1>
      </div>
      <div className="mt-1 flex flex-row items-stretch">
        <div className={`ml-[0.7rem] ${verticalLineStyle}`} />
        <div className="ml-6 h-[10%] w-full">
          <h2 className="mb-2 w-full text-xs font-light text-gray-500">
            {getTimezoneTime(item.time, timezone)} {timezone}
          </h2>
          <div className="rounded-lg border-[1px] border-gray-300 py-1">
            <div className="max-w-[295px] break-words px-1 text-xs font-light">
              {isExpanded ? productionContent : shortProductionContent}
              {productionContent.length > 90 && (
                <button
                  onClick={() => setIsExpanded(!isExpanded)}
                  className="ml-1 text-blue-600 hover:underline"
                >
                  {isExpanded ? "Read Less" : "Read More"}
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductionVolumeItemComponent; 